import { render } from "./CompanyTabLayout.vue?vue&type=template&id=376af64c&scoped=true"
import script from "./CompanyTabLayout.vue?vue&type=script&lang=js"
export * from "./CompanyTabLayout.vue?vue&type=script&lang=js"

import "./CompanyTabLayout.vue?vue&type=style&index=0&id=376af64c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-376af64c"]])

export default __exports__